export { default } from './HeaderSearchLink';
